import React from 'react';

const NavItem = ({ icon, text, onClick, active, badge }) => (
  <button
    onClick={() => {
      onClick();
    }}
    className={`w-full flex items-center justify-between px-4 py-4 rounded-lg transition-colors touch-manipulation ${
      active ? 'bg-blue-600' : 'hover:bg-gray-800 active:bg-gray-700'
    }`}
  >
    <div className="flex items-center space-x-3">
      {icon}
      <span>{text}</span>
    </div>
    {badge && (
      <span className="bg-red-500 text-white text-xs rounded-full px-2 py-1">
        {badge}
      </span>
    )}
  </button>
);

export default NavItem;